<template>
   <form>
      <div class="form-group">
         <div class="row" v-if="errorMssg != null">
            <div class="col-md-12 error_text">
               <p style="color:red; margin-bottom:10px; margin-top:0;">{{errorMssg}}</p>
            </div>
         </div>

         <div class="row">
            <div class="col-sm-6 form-col rg-form">
               <label for="birth_date" class="form-label">Fecha de nacimiento *</label>
               <set-date id="birth_date" @set="function(d){model.birth_date = d}"></set-date>
            </div>
            <div class="col-sm-6 form-col rg-form">
               <label for="state_id" class="form-label">Estado de nacimiento *</label>
               <select id="state_id" v-model="model.state_id" class="form-control" required>
                  <option v-for="state in states" :value="state.id" :key="state.id">{{ state.name }}</option>
               </select>
            </div>
            <div class="col-sm-6 form-col rg-form">
               <label for="bank_id" class="form-label">Banco registrado para la realización de operaciones *</label>
               <input type="text" placeholder="" list="list-banks" v-model="bank" v-on:input="setBankId">
               <datalist id="list-banks">
                  <option v-for="bank in banks" :value="bank.short_name"></option>
               </datalist>
            </div>
         </div>
      </div>
   </form>
</template>

<script>
import SetDate from "@components/shared/SetDate";
export default {
   name: "SLRPerson1",
   components: {SetDate},
   props: {
      states: {
         type: Array,
         required: true,
      },
      banks: {
         type: Array,
         required: true,
      },
   },
   data() {
      return {
         model: {
            birth_date: null,
            state_id: null,
            bank_id: null,
         },
         errorMssg: null,
         bank: null,
      }
   },
   methods: {
      setBankId(){
         const bank = this.banks.filter(bank => bank.short_name===this.bank)[0];
         this.model.bank_id = bank.id;
      },
      checkForm(){
         this.errorMssg = null
         return this.validateFields();
      },
      getPayload(){
         return {
            birth_date: this.model.birth_date,
            birth_state: this.model.state_id,
            bank_id: this.model.bank_id,
         }
      },
      validateFields(){
         let missing = []
         if(this.model.birth_date == null){
            missing.push('Fecha de nacimiento')
         }
         if(this.model.state_id == null){
            missing.push('Estado de nacimiento')
         }
         if(this.model.bank_id == null){
            missing.push('Banco registrado para la realización de operaciones')
         }
         if(missing.length > 0){
            this.errorMssg = `Por favor verifica los siguientes campos: ${missing.join(', ')}`
            return false
         }
         return true
      },
   },
}
</script>